import { Messages } from "./messages-icon"
import { Dashboard } from "./dashboard-icon"
import { CRM } from "./crm-icon"
import { Report } from "./reports-icon"
import { Campaigns } from "./campaigns-icon"
import { Sales } from "./sales-icon"
import { BestAds } from "./best-ads-icon"
import { SideBar } from "./sidebar-icon"
import { Minus } from "./minus-icon"
import { ArrowRight } from "./arrow-right"

export const MessagesIcon = Messages
export const DashboardIcon = Dashboard
export const CRMIcon = CRM
export const ReportIcon = Report
export const CampaignsIcon = Campaigns
export const SalesIcon = Sales
export const BestAdsIcon = BestAds
export const SideBarIcon = SideBar
export const MinusIcon = Minus
export const ArrowRightIcon = ArrowRight